(function () {
    'use strict';

    function configurationEditorController($scope, $route, $routeParams, $location, $log,
        createMode, configurationData, configurationOptionsData, adminEntityConfigurationsData,
        configurationDataService, configurationOptionsDataService, notifyService,
        STATES_LIST) {

        var self = this;

        self.current = configurationData;
        self.configurationIsValid = false;
        self.allEntitySearchFields = [];
        self.allProductSearchFields = [];
        self.originalEntityTypes = [];
        self.allEntityTypes = [];
        self.configurationOptions = configurationOptionsData;
        self.adminEntityConfigurations = adminEntityConfigurationsData;
        self.errors = [];

        self.pageSizes = [5, 10, 15, 20, 25];

        self.$route = $route;
        self.$location = $location;
        self.$routeParams = $routeParams;

        self.createMode = createMode || false;

        function setUpSearchCriterion(searchCriterion, template) {
            searchCriterion.Type = template.$type;
            searchCriterion.Mode = 'Editor';
            searchCriterion.Prompt = searchCriterion.SearchFieldName;
            switch (template.$type) {
            case ("Ecap.Api.Models.Configuration.TextSearchFieldConfiguration, Ecap.Api"):
                searchCriterion.Options = template.Options.map(function(option) {
                    return {
                        Prompt: option.Prompt || option.Value,
                        Value: option.Value
                    }
                });
                searchCriterion.TextSearchFieldType = template.TextSearchFieldType;
                break;
            case ("Ecap.Api.Models.Configuration.IntegerSearchFieldConfiguration, Ecap.Api"):
            case ("Ecap.Api.Models.Configuration.DecimalSearchFieldConfiguration, Ecap.Api"):
                searchCriterion.Options = template.Options.map(function (option) {
                    return {
                        Prompt: option.Prompt || option.Value,
                        Value: option.Value
                    }
                });
                break;
            case ("Ecap.Api.Models.Configuration.StatusSearchFieldConfiguration, Ecap.Api"):
                searchCriterion.Options = [
                    {
                        "Text": "Pending",
                        "Prompt": "Pending"
                    },
                    {
                        "Text": "Approved",
                        "Prompt": "Approved"
                    },
                    {
                        "Text": "NotApproved",
                        "Prompt": "Not Approved"
                    }
                ];
                break;
            }
        }

        self.init = function () {
            var productSearchFieldsMap = {};
            self.configurationOptions.AllProductSearchFields.forEach(function (item) {
                productSearchFieldsMap[item.Prompt] = item;
            });
            self.allProductSearchFields = productSearchFieldsMap;

            self.originalEntityTypes = self.configurationOptions.AdditionalEntityTypes;

            if (createMode) {
                self.current = {
                    Resources: {}
                };
                self.current.FriendlyId = null;
                self.createMode = true;
            }
            else {
                self.current.FriendlyId = self.current.Id.replace("SiteConfigurations/", "");
                self.allEntitySearchFields = getAllEntitySearchFields();
                self.allEntityTypes = getAllEntityTypes();
            }

            // set up default search criteria
            self.current.EntitySearches.forEach(function(search) {
                search.DefaultSearchCriteria.forEach(function(field) {
                    var template = self.allEntitySearchFields[field.SearchFieldName];
                    setUpSearchCriterion(field, template);
                });
            });
        };

        // Remove function
        self.removeItem = function (target, index) {
            target.splice(index, 1);
        };

        // Add function
        self.addItem = function (target, property, data) {
            if (target[property] === undefined) {
                target[property] = [];
            }

            target[property].push(data || {});
        };

        self.setDefaultSearchCriteriaFromTemplate = function (search, index, template) {
            var defaultSearchCriterion = search.DefaultSearchCriteria[index];
            setUpSearchCriterion(defaultSearchCriterion, template);
        }

        self.logConfiguration = function () {
            $log.debug(self.current);
        };

        function getAllEntityTypes() {
            self.allEntityTypes = self.originalEntityTypes;
            var configuredEntityTypes = self.current.Entities.map(function(entity) {
                return {
                    Text: entity.Type,
                    Value: entity.Type
                };
            });

            var allEntityTypes = _.uniq(self.originalEntityTypes.concat(configuredEntityTypes),
                function(entityType) {
                    return entityType.Text;
                });

            return allEntityTypes;
        }

        function getAllEntitySearchFields() {

            var allEntitySearchFields = self.current.Entities ?
                _.flatten(self.current.Entities.map(function(entity) {
                    entity.SearchFields.forEach(function(field) {
                        field.FriendlyPrompt = entity.Type + ' - ' + field.Prompt;
                    });
                    return entity.SearchFields;
                })).concat(
                    _.flatten(self.adminEntityConfigurations.map(function (adminEntity) {
                        adminEntity.SearchFields.forEach(function (field) {
                            field.FriendlyPrompt = adminEntity.Id.split('/')[1] + ' - ' + field.Prompt;
                        });
                        return adminEntity.SearchFields;
                    })))
                : _.flatten(self.adminEntityConfigurations.map(function (adminEntity) {
                    adminEntity.SearchFields.forEach(function (field) {
                        field.FriendlyPrompt = adminEntity.Id.split('/')[1] + ' - ' + field.Prompt;
                    });
                    return adminEntity.SearchFields;
                }));

            self.configurationOptions.DefaultEntitySearchFields.forEach(function(field) {
                field.FriendlyPrompt = field.Prompt;
            });

            allEntitySearchFields = _.uniq(allEntitySearchFields.concat(self.configurationOptions.DefaultEntitySearchFields),
                function (searchField) { return searchField.FriendlyPrompt; });

            // TODO use reduce and merge options
            var map = {};
            allEntitySearchFields.forEach(function (item) {
                map[item.Prompt] = item;
            });

            map["State"].Options = STATES_LIST.filter(function (state) { return state.name !== "" })
                .map(function (state) {
                    return {
                        Prompt: state.name,
                        Value: state.abbrev
                    };
            });

            var searchableAdminEntities = ["Product Provider", "Insurance Broker"];

            if (self.current.Entities) {
                map["EntityType"] = {
                    "$type": "Ecap.Api.Models.Configuration.TextSearchFieldConfiguration, Ecap.Api",
                    "Title": "EntityType",
                    "Prompt": "EntityType",
                    "FriendlyPrompt": "EntityType",
                    "AdminOnly": false,
                    "Options": self.current.Entities ?
                        self.current.Entities.map(function(entity) {
                            return {
                                Value: entity.Type,
                                Prompt: entity.Type,
                                IsSelectedByDefault: false
                            };
                        }).concat(searchableAdminEntities.map(function(adminEntity) {
                            return {
                                Value: adminEntity,
                                Prompt: adminEntity,
                                IsSelectedByDefault: false
                            }
                        })) :
                        searchableAdminEntities.map(function(adminEntity) {
                            return {
                                Value: adminEntity,
                                Prompt: adminEntity,
                                IsSelectedByDefault: false
                            }
                        }),
                    "TextSearchFieldType": "MultiSelect"
                }
            }

            return map;
        }

        self.refreshAllEntityTypes = function() {
            self.allEntityTypes = getAllEntityTypes();
        }

        self.refreshAllEntitySearchFields = function () {
            self.allEntitySearchFields = getAllEntitySearchFields();
        }

        self.saveConfiguration = function () {
            if ($scope.siteConfigurationForm.$valid) {
                self.errors = [];

                if (createMode) {
                    self.current.Id = 'SiteConfigurations/' + self.current.FriendlyId;
                    return configurationDataService.createConfiguration(self.current).then(
                        function (response) {
                            notifyService.notify('The configuration was saved successfully');
                            $location.url('/admin/siteconfigurations/edit/' + self.current.FriendlyId);
                        },
                        function (response) { self.errors = response.data; });
                }
                else {
                    return configurationDataService.saveConfiguration(self.current.FriendlyId, angular.toJson(self.current)).then(
                    function (response) {
                        notifyService.notify('The configuration was saved successfully');
                    },
                    function (response) { self.errors = response.data; });
                }

            } else {
                self.errors = ['Form errors'];
                return false;
            }
        };

        self.logSearchData = function() {
            console.log(self.allEntitySearchFields);
        }

        self.logConfiguration = function () {
            console.log(self.current);
        }

        self.init();
    }

    configurationEditorController.$inject = ['$scope', '$route', '$routeParams', '$location', '$log',
        'createMode', 'configurationData', 'configurationOptionsData', 'adminEntityConfigurationsData',
        'configurationDataService', 'configurationOptionsDataService', 'notifyService',
        'STATES_LIST'];

    angular.module('ecap.siteConfiguration').controller('configurationEditorController', configurationEditorController);
})();
